import { getUSHolidaysInRange } from "@/state/reportv2/convert"
import { PlainDate } from "@/utils/date"
import { useQuery } from "@tanstack/react-query"

export const useUSHolidays = (
	startDate: PlainDate,
	endDate: PlainDate,
	enabled: boolean
) => {
	return useQuery({
		queryKey: ["holidays", startDate.date, endDate.date],
		queryFn: () => getUSHolidaysInRange(startDate, endDate),
		enabled,
	})
}
